import * as React from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { Link } from "react-router-dom";
import { users } from "@/api";
import { omit } from "@/util";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import userIcon from "../../../assets/images/user.svg";
import lockIcon from "../../../assets/images/lock.svg";
import callIcon from "../../../assets/images/call.svg";

const Container = styled.div`
  width: 400px;
  border-radius: 16px;
  background: white;
  justify-content: center;
  align-items: center;
  .atitle {
    display: flex;
    width: 100%;
    align-items: center;
    color: var(--Dark, #0F172A);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    padding-top: 30px;
    padding-bottom: 10px;
    justify-content: center;
  }
  .form {
    width: 280px;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;
  }
  .ant-form-item{
    margin-bottom: 10px;
  }
  .buttonRegister {
    border-radius: 16px;
    background: var(--Brand-color, #00AEEF);
  }
  .icon{
    width: 16px;
    height: 16px;
  }
  .input{
    height: 35px;
    border-radius: 16px;
    border: 1px solid #ECEEF1;
    margin-top: 5px;
  }
  .tag {
    color: #374151;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: -0.12px;
    padding-left: 15px;
  }
`;

const Register: React.FunctionComponent = () => {
  const history = useHistory();
  const [downNumber, setDownNumber] = React.useState(0);
  const [phoneNumber, setPhoneNumber] = React.useState("");

  React.useEffect(() => {
    if (downNumber > 0) {
      setTimeout(() => {
        setDownNumber(downNumber - 1);
      }, 1000);
    }
  }, [downNumber]);

  const buttonTxt = React.useMemo(
    () => (downNumber === 0 ? "Баталгаажуулах код авах" : `${downNumber} S`),
    [downNumber]
  );

  const handleSubmit = async (values: any) => {
    console.log('Received values of form: ', values);
    values.username = values.phone;
    values.checkCode = 123456
    const params: users.RegProps = omit(
      values,
      "cfmPassword"
    ) as users.RegProps;
    await users.regist(params);
    history.replace("/login");
  };

  const sendCaptcha = async () => {
    if (!/1[\d]{10}/.test(phoneNumber)) {
      message.error("Утасны дугаар буруу байна");
      return;
    }
    await users.sendcode(phoneNumber);
    setDownNumber(59);
  };

  const phoneChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setPhoneNumber(v);
  };

  return (
    <Container>
      <Form onFinish={handleSubmit} className="form">
        <div className="atitle">
          Бүртгүүлэх
        </div>
        <span className="tag"> Утасны дугаар </span>
        <Form.Item
          name="phone"
          rules={[{ required: true, message: "Утасны дугаар хоосон байна" }]}
        >
          <Input className="input" prefix={<img className="mr3 ml3 icon" src={callIcon} alt="callIcon" />} placeholder="Утасны дугаараа оруулна уу" onChange={phoneChangeHandler} />
        </Form.Item>
        {/* <Form.Item
          name="username"
          rules={[{ required: true, message: "用户名不能为空" }]}
        >
          <Input placeholder="请输入用户名" />
        </Form.Item> */}
        <span className="tag"> Нууц үг </span>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Нууц үг хоосон байна" }]}
        >
          <Input className="input" prefix={<img className="mr3 ml3" src={lockIcon} alt="lockIcon" />} type="password" placeholder="Нууц үгээ оруулна уу" />
        </Form.Item>
        <span className="tag"> Нууц үг дахин оруулах </span>
        <Form.Item
          name="cfmPassword"
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Нууц үг ижил биш байна"));
              },
            }),
          ]}
        >
          <Input className="input" prefix={<img className="mr3 ml3" src={lockIcon} alt="lockIcon" />} type="password" placeholder="Нууц үгээ дахин оруулна уу" />
        </Form.Item>
        <span className="tag"> Хэрэглэгчийн нэр </span>
        <Form.Item name="nickname">
          <Input className="input" prefix={<img className="mr3 ml3" src={userIcon} alt="userIcon" />} placeholder="Хэрэглэгчийн нэрээ оруулна уу" />
        </Form.Item>

        {/* <Form.Item  >
          <Row gutter={8}>
            <Col span={16}>
              <Form.Item
                name="checkCode"
                noStyle
                // rules={[{ required: true, message: "验证码不能为空" }]}
              >
                <Input placeholder="请输入收到的验证码" defaultValue={123456}  />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button onClick={sendCaptcha} block style={{ width: "100%" }}>
                {buttonTxt}
              </Button>
            </Col>
          </Row>
        </Form.Item> */}

        <Form.Item>
          <Button className="buttonRegister mt10" type="primary" htmlType="submit" block>
            Бүртгүүлэх
          </Button>
        </Form.Item>
        <div className="jsc">
          <Link to="/login">Нэвтрэх</Link>
        </div>
      </Form>
    </Container>
  );
};

export default Register;
